import { useEffect, useState } from "react";
import { ImagePlus, Loader2, X } from "lucide-react";
import { toast } from "sonner";
import { api, imgUrl, errMsg } from "@/lib/api";
import { Spinner } from "@/components/ProtectedRoute";

const Row = ({ c, onChange }) => {
  const [busy, setBusy] = useState(false);
  const save = async (icon) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/categories/${c.id}`, { icon });
      onChange(data);
      toast.success(icon ? "Icona salvata" : "Icona rimossa");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/images", fd);
      await save(data.url);
    } catch (err) {
      toast.error(errMsg(err, "Caricamento icona non riuscito"));
      setBusy(false);
    }
  };
  return (
    <div data-testid={`admin-category-row-${c.id}`} className="card-mc flex items-center gap-3 p-3">
      <div className="grid h-14 w-14 shrink-0 place-items-center overflow-hidden rounded-xl border border-border bg-[#0b0b0f]">
        {c.icon ? <img src={imgUrl(c.icon)} alt="" className="h-12 w-12 object-contain" /> : <span className="text-[10px] font-bold text-white/50">Nessuna</span>}
      </div>
      <div className="flex-1 font-bold">{c.name}</div>
      <label className="btn-ghost-mc cursor-pointer !py-1.5">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ImagePlus className="h-4 w-4" />} {c.icon ? "Cambia" : "Carica icona"}
        <input data-testid={`admin-category-icon-input-${c.id}`} type="file" accept="image/*" className="hidden" onChange={upload} disabled={busy} />
      </label>
      {c.icon && (
        <button data-testid={`admin-category-icon-remove-${c.id}`} aria-label="Rimuovi icona" className="btn-ghost-mc !p-2" disabled={busy} onClick={() => save(null)}>
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};

export default function AdminCategories() {
  const [cats, setCats] = useState(null);
  useEffect(() => {
    api.get("/categories").then(({ data }) => setCats(data));
  }, []);
  if (!cats) return <Spinner />;
  return (
    <div className="space-y-3">
      <p className="text-sm text-muted-foreground">Se carichi un'icona compare in home sopra il nome; altrimenti si vede solo il nome.</p>
      {cats.map((c) => <Row key={c.id} c={c} onChange={setCats} />)}
    </div>
  );
}
